import { validateTidalLicense } from "../../base/index.js";
import { convertRGBAToHexA } from "./convertRGBAToHexA.js";
import { expandHexColor } from "./expandHexColor.js";
validateTidalLicense();
function colorToRGBA(color) {
  const hexColor = color.startsWith("rgb") ? convertRGBAToHexA(color) : color;
  const hex = expandHexColor(hexColor);
  if (!hex) {
    return [0, 0, 0, 255];
  }
  const red = parseHex(hex.substring(1, 3));
  const green = parseHex(hex.substring(3, 5));
  const blue = parseHex(hex.substring(5, 7));
  const alpha = parseHex(hex.substring(7, 9));
  return [red, green, blue, alpha];
}
function parseHex(hex) {
  const result = Number.parseInt(hex, 16);
  if (Number.isNaN(result)) {
    return 0;
  }
  return result;
}
export {
  colorToRGBA
};
//# sourceMappingURL=colorToRGBA.js.map
